<app-protocolo-pesquisa
    [textoBotaoEnvio]="textoBotaoEnvio"
    [tooltipBotaoEnvio]="tooltipBotaoEnvio"
    [routerLinkEnvioLote]="['/solicitacoes-honra/lote/envio']"
    [tiposConteudo]="tiposConteudo"
    [incluirCampoJanelaEnvio]="incluirCampoJanelaEnvio"

></app-protocolo-pesquisa>